import React from "react";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function VelvetyWhiteBeanTomatoStew() {
  return (
    <>
      <HeaderWithSearch />
      <main style={{
        minHeight: "100vh",
        width: "100%",
        background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
        padding: 0,
        margin: 0
      }}>
        <section className="recipe-hero-anim" style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "40vh",
          padding: "60px 0 20px 0"
        }}>
          <h1 className="recipe-title-anim" style={{ fontSize: "3rem", fontWeight: "bold", marginBottom: 12 }}>Velvety white bean and tomato stew</h1>
          <p style={{ fontSize: "1.3rem", color: "#333", marginBottom: 16 }}>The Velvety White Bean and Tomato Stew is a hearty, protein-rich dish made with navy beans, vegetables, and aromatic herbs, perfect for cozy evenings.</p>
          <span className="season-badge season-winter">❄️ Best in Winter</span>
          <ImageWithFallback src="/Velvety_white_bean_and_tomato_stew.jpg" alt="Velvety White Bean and Tomato Stew" className="recipe-image-anim" style={{ width: 340, borderRadius: 24, boxShadow: "0 4px 32px rgba(0,0,0,0.10)", marginBottom: 24, marginTop: 16 }} />
        </section>
        <section className="recipe-columns-anim" style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: 48,
          padding: "20px 0 0 0",
          maxWidth: 1200,
          margin: "0 auto"
        }}>
          <div style={{ flex: 1, minWidth: 320 }}>
            <h2 style={{ fontSize: "2rem", fontWeight: 600, marginBottom: 16, color: "#1a3a5d" }}>Ingredients</h2>
            <ul className="ingredient-list" style={{ fontSize: "1.1rem", color: "#444", lineHeight: 1.7, marginLeft: 18 }}>
              <li>1 pound dried navy beans (cooked)</li>
              <li>Kosher salt and freshly ground pepper</li>
              <li>2 tsp baking soda</li>
              <li>6 cloves garlic, minced</li>
              <li>4 medium carrots</li>
              <li>1 medium onion, sliced into rings</li>
              <li>4 cups vegetable broth</li>
              <li>1 whole peeled tomato</li>
              <li>2 sage sprigs</li>
              <li>1 large or two small rosemary sprigs</li>
              <li>2 bay leaves</li>
              <li>1.5 tsp porcini mushroom powder</li>
              <li>1 large bunch latino kale</li>
              <li>Crusty bread, optional, for serving</li>
              <li>Salt and pepper to taste</li>
              <li>1/3 cup + 1 tbsp olive oil</li>
              <li>Fresh parsley for garnish</li>
            </ul>
          </div>
          <div style={{ flex: 2, minWidth: 320 }}>
            <h2 style={{ fontSize: "2rem", fontWeight: 600, marginBottom: 16, color: "#1a3a5d" }}>Instructions</h2>
            <ol className="instructions-list" style={{ fontSize: "1.1rem", color: "#444", lineHeight: 1.7, marginLeft: 18 }}>
              <li>In a large bowl, cover the dried beans with 8 cups of cold water. Stir 1 tablespoon of kosher salt and the baking soda. Soak for 8 hours, or overnight. Drain with cold water.</li>
              <li>In a large pan, heat 1 tbsp of the oil over medium heat. Add the carrots with a pinch of salt and cook until just starting to soften, 4 - 5 minutes. Add the onion and garlic and cook until the onion has just started to soften, 2 - 4 minutes.</li>
              <li>Add the vegetable broth, peeled tomato, sage, rosemary, bay leaves, and porcini mushroom powder. Bring to a simmer and cook for 20 minutes.</li>
              <li>Stir in the cooked navy beans and kale. Simmer for another 10 minutes until the kale is tender.</li>
              <li>Season with salt and pepper to taste.</li>
              <li>Garnish with fresh parsley and serve warm with crusty bread, if desired.</li>
            </ol>
          </div>
        </section>
        <section style={{ maxWidth: 1200, margin: "0 auto", padding: "24px 24px 60px 24px", display: "flex", gap: 32, flexWrap: "wrap" }}>
          <div className="chef-tips-box" style={{ flex: 1, minWidth: 300, background: "#f8f9fa", padding: 20, borderRadius: 12 }}>
            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
              <span className="tip-icon" role="img" aria-label="chef">👨‍🍳</span> Chef's Tips
            </h3>
            <ul style={{ paddingLeft: 20 }}>
              <li>Soaking the beans with a little baking soda softens their skins so they cook up creamier.</li>
              <li>Simmer gently rather than boiling hard — a rolling boil can make beans burst and turn mushy.</li>
              <li>Porcini powder deepens the savory flavor without needing meat — don't skip it if you have it.</li>
              <li>The stew tastes even better the next day, once the herbs have had time to infuse.</li>
            </ul>
          </div>
          <div className="health-benefits-box" style={{ flex: 1, minWidth: 300, background: "#eef9f0", padding: 20, borderRadius: 12 }}>
            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
              <span className="tip-icon" role="img" aria-label="health">🌿</span> Health Benefits
            </h3>
            <ul style={{ paddingLeft: 20 }}>
              <li>Navy beans are rich in plant protein and fiber, which support digestion and fullness.</li>
              <li>Kale and carrots add vitamins A, C, and K along with antioxidants to the pot.</li>
              <li>A hearty, mostly plant-based stew that's naturally lower in saturated fat than meat-based stews.</li>
              <li>The broth-based cooking method keeps this dish light while still feeling warming and filling.</li>
            </ul>
          </div>
        </section>
      </main>
    </>
  );
}

export default VelvetyWhiteBeanTomatoStew;
